"use strict";
exports.__esModule = true;
exports.StateListener = void 0;
/**
 * Provides a way to store a single value on a key in a DriftDB room, and listen
 * for changes to that value from other clients.
 */
var StateListener = /** @class */ (function () {
    function StateListener(opts) {
        var _this = this;
        var _a;
        this.lastUpdateSent = 0;
        this.lastValue = null;
        this.debounceTimeout = null;
        this.state = null;
        this.callback = opts.callback;
        this.db = opts.db;
        this.key = opts.key;
        this.setStateOptimistic = this.setStateOptimistic.bind(this);
        this.sendUpdate = this.sendUpdate.bind(this);
        this.randId = Math.random().toString(36).substring(7);
        this.debounceMillis = (_a = opts.debounceMillis) !== null && _a !== void 0 ? _a : 20;
        this.handler = function (value) {
            var wv = value.value;
            if (wv.i !== _this.randId) {
                _this.callback(wv.v);
            }
        };
    }
    StateListener.prototype.subscribe = function () {
        this.db.subscribe(this.key, this.handler);
    };
    StateListener.prototype.destroy = function () {
        this.db.unsubscribe(this.key, this.handler);
    };
    StateListener.prototype.onMessage = function (value) {
        this.callback(value.value);
        this.state = value.value;
    };
    StateListener.prototype.sendUpdate = function () {
        var _a;
        if (this.debounceTimeout !== null) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = null;
        }
        var v = { v: this.lastValue, i: this.randId };
        (_a = this.db) === null || _a === void 0 ? void 0 : _a.send({
            type: 'push',
            action: { type: 'replace' },
            value: v,
            key: this.key
        });
    };
    StateListener.prototype.setStateOptimistic = function (value) {
        this.callback(value);
        this.lastValue = value;
        var now = performance.now();
        if (now - this.lastUpdateSent < this.debounceMillis) {
            if (this.debounceTimeout === null) {
                this.debounceTimeout = window.setTimeout(this.sendUpdate, this.debounceMillis);
            }
        }
        else {
            this.lastUpdateSent = now;
            this.sendUpdate();
        }
    };
    return StateListener;
}());
exports.StateListener = StateListener;
